import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";

const rotate = keyframes`
  to { transform: rotate(360deg); }
`;

const fade = keyframes`
  0%, 100% { opacity: 0.35; }
  50% { opacity: 1; }
`;

const CustomLoader = ({ title, subtitle }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        backgroundColor: "rgba(250, 249, 250, 0.54)",
        backdropFilter: "blur(5px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          maxWidth: 380,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 64,
            height: 64,
            display: "grid",
            placeItems: "center",
            mb: 3,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              border: "3px solid rgba(123, 80, 111, 0.12)",
              borderTopColor: "#7b506f",
              animation: `${rotate} 0.9s linear infinite`,
              "@media (prefers-reduced-motion: reduce)": { animation: "none" },
            }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 8,
              borderRadius: "50%",
              border: "2px solid transparent",
              borderBottomColor: "#c18b68",
              animation: `${rotate} 1.4s linear infinite reverse`,
              "@media (prefers-reduced-motion: reduce)": { animation: "none" },
            }}
          />
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#7b506f",
              animation: `${fade} 1.4s ease-in-out infinite`,
              "@media (prefers-reduced-motion: reduce)": { animation: "none" },
            }}
          />
        </Box>

        <Typography
          sx={{
            color: "#2f2730",
            fontSize: { xs: "1rem", sm: "1.05rem" },
            fontWeight: 600,
            lineHeight: 1.4,
            letterSpacing: "-0.01em",
          }}
        >
          {title || "Loading content"}
        </Typography>

        <Typography
          sx={{
            mt: 0.75,
            color: "#766e75",
            fontSize: "0.84rem",
            lineHeight: 1.6,
          }}
        >
          {subtitle || "Please wait while we prepare your workspace."}
        </Typography>

        <Box sx={{ display: "flex", gap: 0.75, mt: 2.25 }} aria-hidden="true">
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: 4,
                height: 4,
                borderRadius: "50%",
                backgroundColor: "#7b506f",
                animation: `${fade} 1.2s ease-in-out ${index * 0.2}s infinite`,
                "@media (prefers-reduced-motion: reduce)": { animation: "none", opacity: 0.5 },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomLoader;
